import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const CheckInCircleIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props} viewBox="0 0 43.1035 43.1035">
      <path
        d="M21.5518 0C33.4317 0 43.1034 9.67187 43.1035 21.5518C43.1035 33.4318 33.4318 43.1035 21.5518 43.1035C9.67187 43.1034 0 33.4317 0 21.5518C0.000130132 9.67195 9.67195 0.00013014 21.5518 0ZM21.5518 2.80762C11.2079 2.80775 2.80775 11.2079 2.80762 21.5518C2.80762 31.8957 11.2079 40.2958 21.5518 40.2959C31.8958 40.2959 40.2959 31.8958 40.2959 21.5518C40.2958 11.2079 31.8957 2.80762 21.5518 2.80762ZM29.2559 14.9043C29.8079 14.3523 30.696 14.3523 31.248 14.9043C31.7999 15.4563 31.8 16.3445 31.248 16.8965L19.584 28.5596C18.984 29.0876 18.0964 29.0876 17.5684 28.5596L12.3604 23.3516C11.8084 22.7996 11.8084 21.9123 12.3604 21.3604C12.9123 20.8084 13.7996 20.8084 14.3516 21.3604L18.2637 25.2725C18.4316 25.4403 18.7197 25.4401 18.8877 25.2725L29.2559 14.9043Z"
        fill="var(--green-700)"
      />
    </IconSvgWrapper>
  );
};

export default CheckInCircleIcon;
